module.exports = __webpack_public_path__ + "img/logo-small.d211b9b4.webp";